import { Auth as DefaultAuth } from 'aws-amplify'

const isJsonString = str => {
  try {
    JSON.parse(str)
  } catch (e) {
    return false
  }
  return true
}

const urlParams =
  typeof window !== 'undefined' && window.location
    ? new URLSearchParams(window.location.search)
    : undefined
const jwtToken = urlParams ? urlParams.get('jwtToken') : undefined
const payload =
  urlParams &&
  urlParams.get('payload') &&
  decodeURIComponent(urlParams.get('payload')) &&
  isJsonString(decodeURIComponent(urlParams.get('payload')))
    ? JSON.parse(decodeURIComponent(urlParams.get('payload')))
    : undefined

export const Auth =
  jwtToken || (typeof window === 'object' && window.vastSessionObject)
    ? {
        currentSession: () => {
          if (typeof window === 'object' && window.vastSessionObject) {
            return new Promise((res, rej) => {
              const now = Math.floor(new Date() / 1000)

              if (
                window.vastSessionObject.expires &&
                now < window.vastSessionObject.expires
              ) {
                return res(window.vastSessionObject)
              }
              return rej('Session is not valid')
            })
          }

          return Promise.resolve({ idToken: { jwtToken, payload } })
        },
        signIn: () => Promise.resolve(),
        signOut: () => Promise.resolve(),
      }
    : {
        ...DefaultAuth,
        currentSession: () =>
          new Promise((res, rej) =>
            DefaultAuth.currentSession()
              .then(session => {
                if (session && session.isValid && session.isValid()) {
                  return res(session)
                }
                return rej('Session is not valid')
              })
              .catch(err => {
                rej(err)
              }),
          ),
        signIn: DefaultAuth.signIn,
        signOut: DefaultAuth.signOut,
      }
